import { Button } from '../../../components/ui/button';
import { closeLoginPopup, focusLoginPopup } from '../../../shared/lib/loginPopup';

/**
 * Пока идёт вход: окно входа отдельное и может спрятаться за браузером или
 * уехать на другой рабочий стол — подсказка, как его вернуть или бросить.
 */
export function LoginPopupHint({ network }: { network: string }) {
  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-1.5 rounded-md border bg-muted/50 px-3 py-2 text-sm">
      <span className="min-w-0 flex-1">
        Вход в {network} открыт в отдельном окне. Не видно окна — оно могло спрятаться за браузером.
      </span>
      <div className="flex gap-2">
        <Button size="sm" variant="outline" onClick={focusLoginPopup}>Показать окно</Button>
        <Button size="sm" variant="ghost" onClick={closeLoginPopup}>Отменить</Button>
      </div>
    </div>
  );
}
